// src/components/CoachingExtras.jsx
import React from "react";
import { Container, Row, Col, Card, Accordion, Button } from "react-bootstrap";
import "../css/coaching-extras.css";

export default function CoachingExtras() {
  return (
    <div className="coaching-extras">
      {/* BENEFITS */}
      <section className="cx-section py-5">
        <Container>
          <Row className="justify-content-center text-center mb-4">
            <Col lg={10}>
              <h2 className="cx-title">Why choose coaching with me</h2>
              <p className="cx-sub text-dark">Real structure, real accountability, real results.</p>
            </Col>
          </Row>

          <Row className="g-4">
            <Col md={6} lg={3}>
              <Card className="cx-card shadow-sm">
                <Card.Body>
                  <div className="cx-emoji" aria-hidden>🎯</div>
                  <Card.Title className="cx-card-title">Tailored Programming</Card.Title>
                  <Card.Text className="mb-0">
                    Plans built around your goals, lifestyle, and training level.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6} lg={3}>
              <Card className="cx-card shadow-sm">
                <Card.Body>
                  <div className="cx-emoji" aria-hidden>💬</div>
                  <Card.Title className="cx-card-title">Accountability</Card.Title>
                  <Card.Text className="mb-0">
                    Check-ins and progress tracking to keep you moving forward.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6} lg={3}>
              <Card className="cx-card shadow-sm">
                <Card.Body>
                  <div className="cx-emoji" aria-hidden>🏋️</div>
                  <Card.Title className="cx-card-title">Pro Background</Card.Title>
                  <Card.Text className="mb-0">
                    Methods shaped by years in Italy’s Serie A as a rugby pro.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6} lg={3}>
              <Card className="cx-card shadow-sm">
                <Card.Body>
                  <div className="cx-emoji" aria-hidden>🔄</div>
                  <Card.Title className="cx-card-title">Flexible Formats</Card.Title>
                  <Card.Text className="mb-0">
                    In-person, online, or hybrid—your plan, your schedule.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      {/* TESTIMONIALS */}
      <section className="cx-section py-5 alt">
        <Container>
          <Row className="justify-content-center text-center mb-4">
            <Col lg={10}>
              <h2 className="cx-title ">Client stories</h2>
              <p className="cx-sub text-dark">A glimpse of what’s possible with consistency and coaching.</p>
            </Col>
          </Row>

          <Row className="g-4">
            <Col md={6} lg={4}>
              <Card className="cx-quote shadow-sm">
                <Card.Body>
                  <blockquote>
                    “I dropped 10 kg and finally built a routine I can stick to.
                    Lyle’s structure and feedback made all the difference.”
                  </blockquote>
                  <div className="cx-quote-meta text-dark">— G., software engineer</div>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6} lg={4}>
              <Card className="cx-quote shadow-sm">
                <Card.Body>
                  <blockquote>
                    “Strength up, pain down. The focus on movement quality was a game changer for my back.”
                  </blockquote>
                  <div className="cx-quote-meta text-dark">— M., photographer</div>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6} lg={4}>
              <Card className="cx-quote shadow-sm">
                <Card.Body>
                  <blockquote>
                    “Clear plan, weekly check-ins, and real progress. Best coaching experience I’ve had.”
                  </blockquote>
                  <div className="cx-quote-meta text-dark">— A., student</div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>

      {/* FAQ */}
      <section className="cx-section py-5">
        <Container>
          <Row className="justify-content-center text-center mb-4">
            <Col lg={10}>
              <h2 className="cx-title">FAQ</h2>
              <p className="cx-sub text-dark">Common questions answered upfront.</p>
            </Col>
          </Row>

          <Row className="justify-content-center">
            <Col lg={10}>
              <Accordion alwaysOpen className="cx-accordion">
                <Accordion.Item eventKey="0">
                  <Accordion.Header>Do I need a gym membership?</Accordion.Header>
                  <Accordion.Body>
                    Not mandatory. We can work with home equipment or bodyweight. If you have a gym, great—we’ll optimize for it.
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                  <Accordion.Header>I’m a beginner. Is coaching for me?</Accordion.Header>
                  <Accordion.Body>
                    Absolutely. We’ll start with fundamentals, nail technique, and progress at a safe pace tailored to you.
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="2">
                  <Accordion.Header>How fast will I see results?</Accordion.Header>
                  <Accordion.Body>
                    It depends on your goal and adherence. Many clients feel improvements in 2–4 weeks and see measurable changes in 8–12 weeks.
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="3">
                  <Accordion.Header>In-person, online, or hybrid?</Accordion.Header>
                  <Accordion.Body>
                    Your choice. In-person (Rome), fully remote, or a hybrid solution. The structure and accountability remain the same.
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </Col>
          </Row>
        </Container>
      </section>

      {/* FINAL CTA */}
      <section className="cx-cta py-5">
        <Container>
          <Row className="align-items-center">
            <Col lg={8}>
              <h3 className="cx-cta-title">Your transformation starts today.</h3>
              <p className="cx-cta-copy">
                Ready to commit? Jump back to the form and request your free discovery call.
              </p>
            </Col>
            <Col lg={4} className="text-lg-end">
              <Button
                className="cx-cta-btn"
                onClick={() => {
                  const el = document.getElementById("consultation");
                  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
                }}
              >
                Go to the form
              </Button>
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
}
